import React, {Component} from 'react'
import Leaves from './Leaves'
import LeavesApi from '../../../api/Leaves'
import {message} from 'antd'
import {get, isEmpty, omit, pick, reduce} from 'lodash'
import omitEmpty from 'omit-empty'
import {sessionItemByKeys} from '../../../modules/Utils'
import EntitlementsApi from '../../../api/Entitlements'
import DocumentsApi from '../../../api/Documents'

class LeavesCont extends Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      fetching: false,
      visible: false,
      leave: {},
      member: this.props.member || {},
      entitlement: {},
      balance: [],
      fetchingBalance: false,
      fetchingLeave: false,
      submitting: false,
      type: 'new',
    }
  }

  api = new LeavesApi()
  entitlementsApi = new EntitlementsApi()
  docsApi = new DocumentsApi()

  componentDidMount() {
    this.fetch()
    this.props.member._id && this.fetchBalance()
  }

  formRef = React.createRef()
  fetchBalance = async id => {
    if (this.props.option === 'personal') id = this.props.member._id
    if (!id) {
      message.error('Select an employee')
      return
    }
    try {
      this.setState({
        fetchingBalance: true,
      })
      const balance = await this.api.entitlements(id.replace('members/', ''))
      this.setState({
        fetchingBalance: false,
        balance: balance.leaves || [],
        entitlement: balance,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetchingBalance: false})
    }
  }
  fetchLeave = async key => {
    try {
      this.setState({
        visible: true,
        type: 'edit',
        fetchingLeave: true,
      })
      const leave = await this.api.read(
        key,
        this.props.option === 'personal' && this.props.member._id,
      )
      const actions = await this.docsApi.actions('leaves', leave.status)
      this.setState({
        fetchingLeave: false,
        leave,
        actions: actions.filter(a => a.key !== 'update' && a.key !== 'remove'),
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetchingLeave: false, visible: false})
    }
  }
  onShow = async (e, leave) => {
    if (!isEmpty(leave)) {
      await this.fetchLeave(leave._key)
    } else {
      this.setState({
        visible: true,
        type: 'new',
        leave: {owner: {_id: get(this.props, 'member._id')}},
      })
      this.props.member._id && (await this.fetchBalance())
    }
  }
  onCancel = () => {
    this.setState({
      visible: false,
      leave: {},
      balance: [],
      member: {},
      entitlement: {},
      currentLeaveCode: '',
    })
    this.formRef.current.resetFields()
  }
  setParentState = state => {
    this.setState(state)
  }
  fetchEntitlements = async () => {
    try {
      this.setState({
        fetchingEntitlements: true,
      })
      const entitlements = await this.entitlementsApi.list()
      let mappedEntitlements = entitlements.map(e => {
        e.leaves = reduce(
          e.leaves,
          (leave, param) => {
            leave[param.code] = {
              ...param,
            }
            return leave
          },
          {},
        )
        return e
      })
      this.setState({
        fetchingEntitlements: false,
        entitlements: mappedEntitlements,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetchingEntitlements: false})
    }
  }
  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const list = await this.api.list(
        this.props.option === 'personal' && {owner: this.props.member._id},
      )
      this.setState({
        fetching: false,
        list,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetching: false})
    }
  }
  process = () => {
    let leave = this.state.leave
    leave.date = {
      start: leave.dateRange[0].format('YYYY-MM-DD'),
      end: leave.dateRange[1].format('YYYY-MM-DD'),
    }
    leave.leave.type = sessionItemByKeys(
      'employee_leaves_dropdown',
      leave.leave.code,
      'code',
      'type',
    )
    leave = omit(leave, [
      'dateRange',
      'total',
      'revision',
      'status',
      'entitlement',
      '_history',
    ])
    return omitEmpty(leave)
  }
  submit = async () => {
    await this.checkForm()
    try {
      this.setState({
        submitting: true,
      })
      let leave = this.process()
      await this.api.create(
        leave,
        this.props.option === 'personal' && this.props.member._id,
      )
      this.setState({
        submitting: false,
      })
      this.formRef.current.resetFields()
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({submitting: false})
    }
  }
  update = async () => {
    await this.checkForm()
    try {
      this.setState({
        submitting: true,
      })
      let leave = this.process()
      leave = omit(leave, ['owner'])
      await this.api.update(
        leave,
        this.props.option === 'personal' && this.props.member._id,
      )

      this.setState({
        submitting: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({submitting: false})
    }
  }
  approve = async l => {
    try {
      this.setState({
        fetchingLeave: true,
      })
      const leave = l || this.state.leave
      await this.api.operation('approve', pick(leave, ['_id', '_key', '_rev']))
      this.onCancel()
      this.setState({
        fetchingLeave: false,
      })
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetchingLeave: false})
    }
  }
  reject = async l => {
    try {
      this.setState({fetching: true})
      const leave = l || this.state.leave
      await this.api.operation('reject', pick(leave, ['_id', '_key', '_rev']))
      this.setState({
        fetching: false,
      })
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetching: false})
    }
  }
  remove = async () => {
    try {
      this.setState({
        removing: true,
      })
      const leave = this.state.leave
      await this.api.remove(
        pick(leave, ['_id', '_key', '_rev']),
        this.props.option === 'personal' && this.props.member._id,
      )
      this.setState({
        removing: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({removing: false})
    }
  }
  checkForm = () => {
    return new Promise(res => {
      this.formRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            leave: Object.assign({}, this.state.leave, values),
          })
          res(true)
        }
      })
    })
  }

  cancel = async () => {
    try {
      this.setState({
        removing: true,
      })
      const leave = this.state.leave
      await this.api.cancel(
        pick(leave, ['_id', '_key', '_rev']),
        this.props.option === 'personal' && this.props.member._id,
      )
      this.setState({
        removing: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({removing: false})
    }
  }

  handleOps = async (operation, leaves) => {
    switch (operation) {
      case 'approve':
        await this.approve(leaves)
        break
      case 'reject':
        await this.reject(leaves)
        break
      case 'cancel':
        await this.cancel(leaves)
        break
    }
  }

  onChangeLeaveCode = code => {
    this.setState({
      currentLeaveCode: code,
    })
  }
  onChangeEmployee = async value => {
    await this.fetchBalance(value)
    this.setState({
      member: {
        _id: value,
      },
    })
  }

  render() {
    const {option} = this.props
    return (
      <Leaves
        option={option}
        {...this.state}
        {...pick(this, [
          'onSelectEvent',
          'fetch',
          'fetchBalance',
          'onCancel',
          'onShow',
          'submit',
          'update',
          'setParentState',
          'fetchEntitlements',
          'approve',
          'reject',
          'remove',
          'formRef',
          'onChangeLeaveCode',
          'handleOps',
          'onChangeEmployee',
        ])}
      />
    )
  }
}

LeavesCont.propTypes = {}
LeavesCont.defaultProps = {
  option: 'hr',
  member: {},
}

export default LeavesCont
